/**
 * @file Album folder upsell for checkout pages.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Button from '../global/Button';
import { formatPriceForDisplay } from '../../util/format-money';
import Alert from '../global/Alert';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    price: PropTypes.shape({
      value: PropTypes.number,
    }),
  }),
  className: PropTypes.string,
  onUpsellClick: PropTypes.func,
};

const AlbumFolderCheckoutUpsell = ({ albumFolder, className, onUpsellClick }) =>
  albumFolder && albumFolder.price.value ? (
    <Alert type="info" className={className}>
      <h4>Psst&hellip;</h4>

      <p className="text-base">
        Want all <strong>{albumFolder.name}</strong> photos? Purchase a
        subscription and avoid single purchase downloads!
      </p>

      <Button btnBlock btnOutline btnSize="sm" onClick={onUpsellClick}>
        I want the subscription &ndash; $
        {formatPriceForDisplay(albumFolder.price.value)}
      </Button>
    </Alert>
  ) : null;

AlbumFolderCheckoutUpsell.propTypes = propTypes;

export default AlbumFolderCheckoutUpsell;
